import { ProductName } from '@banking/ui/models/checking/product-positioning';
export default function (productName, translationBaseKeyPath) {
  switch (productName) {
    case ProductName.CheckingAndDebit:
      return `${translationBaseKeyPath}.checkingAndDebit`;
    case ProductName.SquareCard:
      return `${translationBaseKeyPath}.squareCard`;
    case ProductName.None:
      throw new Error('ProductName.None is not supported');
  }
}